import { OneButton, OneModal } from '@yy/one-ui'
import React from 'react'
import { useTranslation } from 'react-i18next'
import Cookies from 'js-cookie'
import twofaImg from '@common/oneclub/assets/imgs/2fa.png'
import styles from './index.module.less'
import { useBoolean } from 'ahooks'
import { SecurityPage } from '@sl/merchant-security-npm'
import { useSelector } from '@common/oneclub/store'

interface TwoStepVerifySettingProps {
  loginSuccessCb: () => void
  mustSet?: boolean
}
/**
 * 提醒设置2fa
 * @param param0
 * @returns
 */
export const TwoStepVerifySetting: React.FC<TwoStepVerifySettingProps> = ({ loginSuccessCb, mustSet }) => {
  const { t } = useTranslation()
  const [visible, visibleActions] = useBoolean()
  const uid = Cookies.get('osudb_uid')
  const languageType = useSelector((state) => state?.language.languageType)

  return (
    <div className={styles.root}>
      <h1>{t('login.2fa.setting')}</h1>
      <p>{mustSet ? t('login.2fa.setting.sub.desc') : t('login.2fa.setting.tip')}</p>
      <div className={styles.card}>
        <div>
          <h3>{t('2fa.title')}</h3>
          <span>{t('login.2fa.setting.desc')}</span>
        </div>
        <img src={twofaImg} />
      </div>
      <OneButton type="primary" color="primary" className={styles.normalButton} onClick={visibleActions.setTrue}>
        {t('login.2fa.setting.turnOn')}
      </OneButton>
      {mustSet ? null : (
        <OneButton type="default" className={styles.normalButton} onClick={loginSuccessCb}>
          {t('login.2fa.setting.next')}
        </OneButton>
      )}
      <OneModal title={t('2fa.title')} visible={visible} footer={null} onCancel={visibleActions.setFalse} closable={!mustSet}>
        <div className={styles.securityPage}>
          <SecurityPage
            env={process.env.SECURITY_ENV}
            bizSource={process.env.SECURITY_BIZ_SOURCE}
            uid={uid}
            lang={languageType}
            hiddenTitle
            onSuccess={() => {
              visibleActions.setFalse()
              loginSuccessCb()
            }}
          />
        </div>
      </OneModal>
    </div>
  )
}
